import { CellularProviderType } from "@app/shared/databases/cellular.database.service";
import { DbHelper } from "@app/shared/model/db-object.model";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

/* eslint-disable @typescript-eslint/naming-convention */
export interface SecuritySystemData {
    mac_address?: string;
    name?: string;
    create_time?: number;
    id?: number;
    imei?: string;
    iccid: string;
    meid?: string;
    cellular_provider?: string;
    is_completed?: boolean;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class SecuritySystem {
    static dbTypeName = "Security";
    static dbEndpoint = "securitysystem";

    static readonly importMap: ImportMap<SecuritySystem, SecuritySystemData> = [
        { i: "mac_address", o: "macAddress" },
        { i: "name", o: "name" },
        { i: "create_time", o: "createTime", skipExport: true },
        { i: "id", o: "id" },
        { i: "imei", o: "imei" },
        { i: "iccid", o: "iccid" },
        { i: "meid", o: "meid" },
        { i: "cellular_provider", o: "cellularProvider" },
        { i: "is_completed", o: "isCompleted" },
    ];

    static fromDbObject(controller): SecuritySystem {
        if (controller) {
            return new SecuritySystem(
                controller[SecuritySystem.importMap[0].i],
                controller[SecuritySystem.importMap[1].i],
                controller[SecuritySystem.importMap[4].i],
                controller[SecuritySystem.importMap[5].i],
                controller[SecuritySystem.importMap[6].i],
                controller[SecuritySystem.importMap[2].i],
                controller[SecuritySystem.importMap[3].i],
                controller[SecuritySystem.importMap[7].i],
                controller[SecuritySystem.importMap[8].i]
            );
        }
        return null;
    }

    constructor(
        public macAddress: string,
        public name: string = "Security",
        public imei?: string,
        public iccid?: string,
        public meid?: string,
        public createTime?,
        public id?: number,
        public cellularProvider: CellularProviderType = CellularProviderType.NONE,
        public isCompleted: boolean = false
    ) {}
}

export class SecuritySystemHelper extends DbHelper<SecuritySystem, SecuritySystemData> {
    static readonly importMap: ImportMap<SecuritySystem, SecuritySystemData> = [
        { i: "mac_address", o: "macAddress" },
        { i: "name", o: "name" },
        { i: "create_time", o: "createTime", skipExport: true },
        { i: "id", o: "id" },
        { i: "imei", o: "imei" },
        { i: "iccid", o: "iccid" },
        { i: "meid", o: "meid" },
        { i: "cellular_provider", o: "cellularProvider" },
        { i: "is_completed", o: "isCompleted" },
    ];

    importMap = SecuritySystemHelper.importMap;
}
